/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Purchase {
    import fld = ApprovalInReturnBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ApprovalInReturnBOMEditor extends _Ext.BOMGridEditor<ApprovalInReturnBOMRow> { 
        protected getDialogType() { return ApprovalInReturnBOMDialog; }
        protected getLocalTextPrefix() { return ApprovalInReturnBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as Purchase.ApprovalInReturnItemsDialog).CalculateTotals();
                }
            })
        }
          
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

    }
}